import About from '../components/about/About'
import Card from '../components/card/Card'
import Parallax from '../components/parallax/parallax'
import ReservationEngine from '../components/ReservationEngine'
import Swiper from '../components/slider/Swiper'
import type { Route } from './+types'

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Pousada Casa Kuava" },
    { name: "description", content: "Pousada em Barra Grande, Maragogi-AL. Próxima ao Caminho de Moisés" },
  ];
}

export default function index() {
  return (
    <>
      <div className="full-page">
        <Swiper></Swiper>
        <ReservationEngine />
      </div>
      <div className="flex flex-wrap justify-center my-10">
        <Card title="A Pousada" image="/home/01.webp" href="/a-pousada">
          A Kuava fica Localizada em uma das melhores Praias do Nordeste
        </Card>
        <Card title="Acomodações" image="/home/9.jpg" href="/acomodacoes">
          Os Quartos são confortáveis e cheios de charme
        </Card>
        <Card title="Lazer" image="/home/h3.jpg" href="/lazer">
          Estamos a alguns metros do Caminho de Moisés
        </Card>
      </div>
      <Parallax></Parallax>
      <About></About>
    </>
  )
}
